/* eslint-disable camelcase,max-statements,consistent-return,no-invalid-this */
import AccessImage from "public/images/products/access.svg";
import moment from "moment";
import PayImage from "public/images/products/pay.svg";
import TargetImage from "public/images/products/target.svg";
import TicketImage from "public/images/products/ticket.svg";
import Event from "./event";

/**
 * Class for Historic
 * @param {Object} action_data - Data of the action
 * @param {Object} contact_data - Data of the contact like email, first_name ..
 * @param {Datetime} date - Date of the action
 * @param {Object} event - Event of the historic from an event
 * @param {string} id - Id of the historic like "transactionParticipation:89294777"
 * @param {string} type - Type of the action like scan, campaign ..
 * @returns {Class} - Historic's Class
 */
export default class Action {
	constructor({
		action_data,
		external_status,
		contact_data,
		date,
		event,
		id,
		type
	} = {}) {
		this._action_data = action_data || {};
		this._external_status = external_status || {};
		this._contact_data = contact_data || {};
		this._date = date ? moment(date) : null;
		this._event = event ? new Event(event) : null;
		this._id = id;
		this._type = type || null;
	}

	getKey = () => String(this._id);

	/* Getters of historic */
	getActionData = () => this._action_data;

	getExternalStatus = () => this._external_status;

	getContactData = () => this._contact_data;

	getDate = () => this._date;

	getEvent = () => this._event;

	getId = () => this._id;

	getType = () => this._type;

	/* Type of historic */
	isCampaign = () => this.getType() === "campaign";

	isConnectApp = () => this.getType() === "connect-app";

	isDownloadApp = () => this.getType() === "download-app";

	isList = () => this.getType() === "enter-list";

	isMailCampaign = () => this.getType() === "MailCampaignAction";

	isParticipant = () => this.getType() === "transactionParticipation";

	isPurchase = () => this.getType() === "transactionAchat";

	isScan = () => this.getType() === "scan";

	isUnsubscribe() {
		return this.getType() === "bim-unsubscribe";
	}

	isExitingList() {
		return this.getType() === "exit-list";
	}

	/**
	 * Find the SVG's icon of product
	 * @return {string} - The name of the icon to display
	 */
	getProductName = () => {
		if (this.isScan()) {
			return "access";
		}
		if (this.isParticipant() || this.isPurchase()) {
			return "ticket";
		}
		if (this.isConnectApp() || this.isDownloadApp()) {
			return "pay";
		}

		return "target";
	}

	getProductImage = () => {
		if (this.isScan()) {
			return AccessImage;
		}

		if (this.isParticipant() || this.isPurchase()) {
			return TicketImage;
		}

		if (this.isConnectApp() || this.isDownloadApp()) {
			return PayImage;
		}

		return TargetImage;
	}
}
